'use client';

import { type ReactElement } from 'react';
import { Link } from '@/components/link';
import { useBasketSnapshot } from '@/providers/basket';
import CartBadgeIcon from './cart-badge-icon';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { useCommerceEnabled } from '@/hooks/use-commerce-enabled';

export default function CartBadge(): ReactElement | null {
    const snapshot = useBasketSnapshot();
    const { t } = useTranslation('cart');
    const commerceEnabled = useCommerceEnabled();
    const numberOfItems = snapshot?.totalItemCount ?? 0;

    if (!commerceEnabled) {
        return null;
    }

    return (
        <Button
            asChild
            variant="ghost"
            className="relative cursor-pointer hover:bg-transparent hover:text-primary"
            aria-label={t('badge.ariaLabel', { count: numberOfItems })}>
            <Link to="/cart">
                <CartBadgeIcon numberOfItems={numberOfItems} />
            </Link>
        </Button>
    );
}
